import { Request } from '~~/plugins/fetch'
import { gateway, gatewayV2 } from '~~/config'
import { PROTOCOL_TYPE } from '@/enum'
/**
 * 协议详情请求参数
 */
export interface IProtocol {
  protocolType: PROTOCOL_TYPE
  country: string
  vehicleType?: string
}

/**
 * 协议详情响应参数
 */
export interface IProtocolRes {
  protocolName: string
  content: string
  contentType: number
  url: string
  list: string
  hisProtocol: {
    protocolName: string
    content: string
    contentType: number
    url: string
  }
}

export interface IHistoryList {
  pageIndex: number
  pageSize: number
  protocolType: number
  vin: string
}

/**
 * 基于传入版本号的协议详情请求参数
 */
export interface IProtocolByVersion extends IProtocol {
  protocolVersion: string
}

export interface IAgreementLisRes {
  protocolVersion: string
}

// 请求协议内容(根据版本)
export const getProtocolByVersion = (data: IProtocolByVersion) => {
  return Request.get<IProtocolByVersion, IProtocolRes>({
    url: `${gateway}/complaintsComments/route/getProtocolContent`,
    data,
  })
}

// 请求协议内容
export const getProtocol = (data: IProtocol) => {
  return Request.get<IProtocol, IProtocolRes>({
    url: `${gateway}/complaintsComments/route/getAgreementContent`,
    data,
  })
}

// 请求积分规则内容
export const getPointRules = () => {
  return Request.get<null, { detail: string }>({
    url: `/point-task/api/v1.0/task/getPointDesc`,
  })
}

// 请求邀请注册规则内容
export const getInviteRules = () => {
  return Request.get<null, { activityRule: string }>({
    url: `${gateway}/userAuth/getInviteRule`,
  })
}

// 分页按类型查询历史签署的协议
export const queryUserProtocolRecord = (data: IHistoryList) => {
  return Request.post<
    IHistoryList,
    { list: Array<{ protocolVersion: string }>; totalPage: number; total: number }
  >({
    url: `${gatewayV2}/userAuth/queryUserProtocolRecord`,
    data,
  })
}
